import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalIsTextContentEmpty } from '@lexical/react/useLexicalIsTextContentEmpty';

interface PlaceholderPluginProps {
    placeholder?: string;
}

export function PlaceholderPlugin({ placeholder }: PlaceholderPluginProps) {
    const [editor] = useLexicalComposerContext();
    const isEmpty = useLexicalIsTextContentEmpty(editor);

    // set the placeholder on root
    useEffect(() => {
        const rootElement = editor.getRootElement();
        if (!rootElement) {
            return;
        }

        if (isEmpty && placeholder) {
            rootElement.setAttribute('placeholder', placeholder);
        } else {
            rootElement.removeAttribute('placeholder');
        }
    }, [editor, isEmpty, placeholder]);

    return null;
}

export default PlaceholderPlugin;
